import React, { useContext, useState, useRef } from 'react'
import Status from '../Components/Status/Status';
import { Oval } from 'react-loader-spinner';
// import ProgressBar from "@ramonak/react-progress-bar";
import EditIcon from '@mui/icons-material/Edit';
import CameraIcon from '@mui/icons-material/PhotoCamera';
import axios from 'axios';
import { useQuery } from 'react-query';
import { baseUrl, path } from '../constants';
import { Link } from 'react-router-dom';
import {api} from '../api'
import { appContext } from '../Context/appProvider';

export default function Account() {
    const {user, setUser, setNotification} = useContext(appContext)
    const [editName, setEditName] = useState(false)
    const [profileUploading, setProfileUploading] = useState(false)
    const [bannerUploading, setBannerUploading] = useState(false)
    const profileRef = useRef()
    const bannerRef = useRef()

    const uploadImage = (file, type) => {
        if(!file) return window.alert('Please select a file')
        let form  = new FormData()
        if(type == 'image') setProfileUploading(true)
        else setBannerUploading(true)
        form.append('file', file)
        axios(baseUrl + path.uploadFile + '?to=images', {
            data: form,
            method: 'post',
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(response => {
            if(response.data.success){
                let source = response.data.source
                api(path.myAccount, {
                    method: 'post',
                    data: {
                        [type]: response.data.source
                    }
                }).then(response => {
                    if(response.data.success){
                        setNotification({
                            message: 'Image successfully updated!',
                            visible: true,
                            type: 'success'
                        })
                        setUser({...user, [type]: source})
                    }
                }).finally(() => {
                    if(type == 'image') setProfileUploading(false)
                    else setBannerUploading(false)
                })
            }
        })
    }

    console.log(user)
    
    return ( 
        <div className='flex flex-col gap-5 max-md:gap-2 h-full w-full bg-white rounded-sm p-4 overflow-y-auto'>
            <h2 className='text-black text-[18px] font-bold'>My Account (Public Profile)</h2>
            <div className='flex-1 p-5 max-md:p-0'>
                <div className='h-[180px] max-md:h-[80px] w-full bg-[#e2e2e2] relative rounded-md overflow-hidden'>
                    <img className='w-full h-full object-cover' src={baseUrl + user.cover} />
                    <input ref={bannerRef} onChange={e => uploadImage(e.target.files[0], 'cover')} type='file' className='hidden' />
                    <button onClick={() => bannerRef.current.click()} className='absolute bg-[#000000] right-[20px] max-md:right-[5px] bottom-[20px] flex items-center justify-center gap-1 text-white mt-2 border-[1px] text-sm rounded-md px-2 py-1'>
                        {bannerUploading ? (
                            <Oval
                                visible={true}
                                height="24"
                                width="25"
                                color="#ffffff"
                                ariaLabel="oval-loading"
                                wrapperStyle={{}}
                                wrapperClass=""
                                strokeWidth={3}
                            /> ) : <CameraIcon style={{fontSize: 20, color: '#ffffff'}}>Filled</CameraIcon> }
                        Change Banner
                    </button>
                </div>
                <div className='flex gap-4 mt-4'>
                    <div className='flex flex-col'>
                        <img src={baseUrl + user.image} className='w-[150px] h-[150px] max-md:w-[100px] max-md:h-[100px] rounded-full border-[3px] object-cover border-main' />
                        <input ref={profileRef} onChange={e => uploadImage(e.target.files[0], 'image')} type='file' className='hidden' />
                        <button onClick={() => profileRef.current.click()} className='flex items-center max-md:whitespace-nowrap max-md:text-xs justify-center gap-1 text-black mt-2 border-[1px] text-sm rounded-md px-2 max-md:gap-1 py-1'>
                        {profileUploading ? (
                            <Oval
                                visible={true}
                                height="24"
                                width="25"
                                color="#000000"
                                ariaLabel="oval-loading"
                                wrapperStyle={{}}
                                wrapperClass=""
                                strokeWidth={3}
                            /> ) : <CameraIcon style={{fontSize: 20, color: '#000000'}}>Filled</CameraIcon> }
                            Change Profile
                        </button>
                    </div>
                    <div className='flex flex-col gap-1 justify-center'>
                        <div className='flex gap-2 items-center'>
                            <h1 className='text-[28px] font-bold tracking-wider max-md:text-[20px] max-md:tracking-wide'>{`${user.firstName} ${user.lastName}`}</h1>
                            <button onClick={() => setEditName(true)}>
                                <EditIcon style={{fontSize: 20}}>Filled</EditIcon>
                            </button>
                        </div>
                        <p className='font-bold text-sm py-1 px-2 bg-black text-white w-fit rounded-md'>{user.isInstitute ? 'Institute' : 'Institute'}</p>
                    </div>
                </div>
            </div>

            {editName && <EditName setEditName={setEditName} /> }
        </div>
    )
}


function EditName({ setEditName }){
    const {user, setUser, setNotification} = useContext(appContext)
    const [firstName, setFirstName] = useState(user.firstName)
    const [lastName, setLastName] = useState(user.lastName)
    const [submitting, setSubmitting] = useState(false)

    const saveChanges = () => {
        setSubmitting(true)
        api(path.myAccount, {
            method: 'post',
            data: {
                firstName,
                lastName
            }
        }).then(response => {
            if(response.data.success){
                setNotification({
                    message: 'Name successfully updated!',
                    visible: true,
                    type: 'success'
                })
                setEditName(false)
                setUser({...user, firstName, lastName})
            } else {
                setNotification({
                    message: response.data.message,
                    visible: true,
                    type: 'error'
                })
            }
        }).finally(() => setSubmitting(false))
    }

    return (
        <div className='fixed bg-[#00000060] inset-0 flex items-center justify-center'>
            <div className='bg-white flex flex-col items-center gap-6 p-4 rounded-md'>
                <h1>Edit Name</h1>
                <input value={firstName} onChange={event => setFirstName(event.target.value)} placeholder={'First Name'} type='text' className='border-[1px] border-solid border-[#00000090] text-black placeholder:text-[#434343] p-2 w-[300px]' />
                <input value={lastName} onChange={event => setLastName(event.target.value)} placeholder={'Last Name'} type='text' className='border-[1px] border-solid border-[#00000090] text-black placeholder:text-[#434343] p-2 w-[300px]' />
                <div className='flex self-stretch gap-2'>
                    <button disabled={!firstName || submitting} onClick={saveChanges} type='submit' className={`${(!firstName) ? 'bg-[#a3a3a3]' : 'bg-main'} text-white text-[14px] flex-1 p-2 flex items-center justify-center`}>
                    {submitting ? (
                            <Oval
                                visible={true}
                                height="21"
                                width="21"
                                color="#ffffff"
                                ariaLabel="oval-loading"
                                wrapperStyle={{}}
                                wrapperClass=""
                                strokeWidth={3}
                            />
                        ) : 'Update'}
                    </button>
                    <button onClick={() => setEditName(false)} className='border-[1px] border-[#00000070] p-2 text-[14px] flex-1'>
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    )
}
